import React from 'react';
import { Box, Text } from '@chakra-ui/react';

// Size buttons (design-system.md §4.3): 70×40 desktop / 50×28 phone, radius 10, #E1E0EC border;
// hover → black border, selected → black fill. `compact` forces the small size (drawers).
const SizeSelector = ({ sizes = [], value, onChange, onSizeChart, compact = false, label = true }) => (
    <Box>
        {label &&
            <Box display='flex' alignItems='baseline' justifyContent='space-between' mb='12px' >
                <Text fontSize='15.2px' color='blackAlpha.600' >Size: {value && <Box as='span' color='raano.black' >{value}</Box>}</Text>
                {onSizeChart && <Text as='button' type='button' fontSize={{ base: '12px', md: '14px' }} fontWeight={500} textDecoration='underline' onClick={onSizeChart} >Size Chart</Text>}
            </Box>}
        <Box role='radiogroup' aria-label='Size' display='flex' flexWrap='wrap' gap={compact ? '8px' : { base: '10px', md: '12px' }} >
            {sizes.map(size => {
                const selected = value === size;
                return (
                    <Box
                        key={size}
                        as='button'
                        type='button'
                        role='radio'
                        aria-checked={selected}
                        minWidth={compact ? '52px' : { base: '50px', md: '70px' }}
                        height={compact ? '36px' : { base: '28px', md: '40px' }}
                        px='10px'
                        borderRadius='sizeBtn'
                        border='1px solid'
                        borderColor={selected ? 'raano.black' : 'raano.sizeBorder'}
                        bg={selected ? 'raano.black' : 'raano.white'}
                        color={selected ? 'raano.white' : 'raano.black'}
                        fontSize='14px'
                        fontWeight={600}
                        letterSpacing='0.28px'
                        transition='border-color .125s, background-color .125s, color .125s'
                        _hover={{ borderColor: 'raano.black' }}
                        _focusVisible={{ outline: '2px solid', outlineColor: 'raano.black', outlineOffset: '2px' }}
                        onClick={() => onChange(size)}
                    >{size}</Box>
                );
            })}
        </Box>
    </Box>
);

export default SizeSelector;
